import { render, staticRenderFns } from "./PanelDistribuidor.vue?vue&type=template&id=faca14b0&scoped=true"
import script from "./PanelDistribuidor.vue?vue&type=script&lang=js"
export * from "./PanelDistribuidor.vue?vue&type=script&lang=js"
import style0 from "./PanelDistribuidor.vue?vue&type=style&index=0&id=faca14b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faca14b0",
  null
  
)

export default component.exports